import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import '../../../modules/companies/register-panels'
import '../../../modules/contacts/register-panels'
import '../../../modules/deals/register-panels'
import '../../../modules/logs/register-panels'
import { LogsView } from '../../../modules/logs/logs-view'
import { PANEL_TYPES } from '../../../shell/panel-state'

const logsSearchSchema = z.object({
  q: z.string().optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  filter: FilterExprSchema.optional(),
  quick: FilterExprSchema.optional(),
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
  pstack: z.string().optional(),
})

export const Route = createFileRoute('/_authed/logs/change-history')({
  validateSearch: logsSearchSchema,
  component: ChangeHistoryRoute,
})

function ChangeHistoryRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <LogsView
      kind="change"
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => cleanSearch({ ...prev, ...patch })) as never,
          replace: true,
        })
      }
    />
  )
}

function cleanSearch(next: Record<string, unknown>) {
  for (const [key, value] of Object.entries(next)) {
    if (value == null || value === '') delete next[key]
  }
  return next
}
